import { useLocation } from 'react-router-dom';
import { Button, ComingSoon, Footer, Header, Hero, LoadingSymbol, LoginModal, RequireAuth } from '../components';
import { useDevice } from '../hooks';
import { useContext } from 'react';
import { UserContext } from '../contexts/user.context';
import { UserProviderValue } from '../models';
import { getLinkWithParams } from '../utils';

export function PageLayout(
   props: Readonly<{
      page: any;
      blank?: boolean;
      hero?: {
         enabled?: boolean;
         title?: string;
         actions?: {
            label: string;
            onClick: () => void;
         }[];
      };
      comingSoon?: boolean;
      left?: boolean;
      smaller?: boolean;
      requireAuth?: boolean;
   }>
) {
   const { isAuthenticated, isLoginModalOpen, setIsLoginModalOpen } = useContext<UserProviderValue>(UserContext);
   const { page, hero, comingSoon, left, smaller, requireAuth, blank } = props;
   const { isMobile } = useDevice();
   const location = useLocation();

   const isNotRootRoute = location.pathname !== '/';

   if (blank) {
      return page;
   }

   return (
      <div className="App">
         <div className="">
            <Header />

            <main>
               <LoginModal
                  isOpen={isLoginModalOpen}
                  onClose={() => setIsLoginModalOpen(false)}
               />
               <div className={`flex flex-col justify-between page-layout `}>
                  {hero?.enabled && <Hero title={hero.title ?? 'Do More, Earn More'} />}

                  <div className={`page-content flex ${!left ? '' : ''} ${smaller ? 'page-content-smaller' : ''}  flex-col gap-3`}>
                     {isAuthenticated === undefined ? (
                        <div className="flex justify-center">
                           <LoadingSymbol size={24} />
                        </div>
                     ) : (
                        <>
                           {isMobile && (
                              <div className="flex justify-start">
                                 <div className="flex flex-col  gap-4">
                                    {isNotRootRoute && (
                                       <div className="flex justify-start">
                                          <Button
                                             type="transparent"
                                             to={getLinkWithParams('/')}
                                             children={
                                                <div className="flex items-center gap-1">
                                                   <img
                                                      src="/assets/icons/arrow-back.svg"
                                                      alt="GolfN"
                                                      width={8}
                                                   />
                                                   <span>Back</span>
                                                </div>
                                             }></Button>
                                       </div>
                                    )}
                                    <h2>{hero?.title ?? 'Do More, Earn More'}</h2>
                                 </div>
                              </div>
                           )}{' '}
                           {comingSoon ? <ComingSoon /> : requireAuth && !isAuthenticated ? <RequireAuth openLoginModal={() => setIsLoginModalOpen(true)} /> : page}
                        </>
                     )}
                  </div>
               </div>
            </main>
         </div>
         <Footer />
      </div>
   );
}
